/**
 * Correct a domain URL by ensuring it has a valid scheme and no path.
 */
const correctDomainUrl = (url: string): string => {
  if (!url || url.trim() === "") {
    return url;
  }

  const trimmed = url.trim();

  // Basic validation: if it doesn't contain a protocol and doesn't look like a valid domain, return as-is
  if (
    !trimmed.includes("://") &&
    !trimmed.includes(".") &&
    !trimmed.includes(":")
  ) {
    return url;
  }

  try {
    let normalizedUrl = trimmed;

    // Handle protocol-relative URLs (//example.com)
    if (normalizedUrl.startsWith("//")) {
      normalizedUrl = "https:" + normalizedUrl;
    }
    // Handle malformed URLs with missing protocol (://example.com)
    else if (normalizedUrl.startsWith("://")) {
      normalizedUrl = "https" + normalizedUrl;
    }
    // Handle URLs without protocol
    else if (!normalizedUrl.includes("://")) {
      normalizedUrl = "https://" + normalizedUrl;
    }
    // Handle non-HTTP protocols by replacing them with https
    else if (
      normalizedUrl.match(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//) &&
      !normalizedUrl.match(/^https?:/)
    ) {
      normalizedUrl = normalizedUrl.replace(/^[^:]+:/, "https:");
    }

    const urlObj = new URL(normalizedUrl);

    // Always use HTTPS
    urlObj.protocol = "https:";

    // Remove authentication info
    urlObj.username = "";
    urlObj.password = "";

    // Return only the origin (protocol + hostname + port)
    return urlObj.origin;
  } catch {
    // If URL parsing fails, return the original input
    return url;
  }
};
export { correctDomainUrl };
